export class ComercialModel {

    filtro_data_inicial: Date
    filtro_data_final: Date
    

    cod_orcamento?: string
    situacao?: string
    coligada?: string
    venda_total?: number
    valor_parcelas?: number
    data?: Date
    aprovacao?: Date
    nome?: string
    endereco?: string
    numero?: string
    descricaoTitulo?: string
    total_dinheiro?: number
    quantidade_orcamento?: number
    media_orcamento?: number
    setor?: string
    grupo?: string
    vendedor?: string

    total_dinheiro_texto?: string
    quantidade_orcamento_texto?: string
    media_orcamento_texto?: string

}
